var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredictionPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34375 0.125L0.125 0.765625V19.5156L1.34375 20.1719L15.4062 10.7969V9.5L1.34375 0.125ZM1.6875 18.0625V2.23437L13.5625 10.1562L1.6875 18.0625Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 19.9422L20.0938 10.7969V9.49999L6.375 0.354675V2.23436L18.25 10.1562L6.375 18.0625V19.9422Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictionPageIcon);
export default __webpack_public_path__ + "static/media/prediction-page-icon.dcfd5bdb363118a44a0311061fba171f.svg";
export { ForwardRef as ReactComponent };